import { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { caiDarkColors, caiLightColors } from './caiBrand';

/**
 * The single mode-decision point for Connect-AI: every `caiColors[k]` reads
 * `var(--cai-{k}, <light literal>)`, and this component is the only place that writes
 * `--cai-*` onto `<html>`. No Connect-AI call site branches on `palette.mode` itself.
 *
 * In light mode the properties are removed, not set to the light values — the SSR'd
 * fallback already is the light value, so removing is what keeps light mode provably
 * unchanged instead of merely matching by coincidence.
 *
 * Keyed on `palette.mode` alone, not `theme`: the theme identity changes on every
 * customizer tweak, and only the mode actually changes what this writes.
 */
function CaiThemeVars() {
  const { palette: { mode } } = useTheme();

  useEffect(() => {
    const root = document.documentElement;

    if (mode === 'dark') {
      Object.entries(caiDarkColors).forEach(([key, value]) => {
        root.style.setProperty(`--cai-${key}`, value);
      });
    } else {
      Object.keys(caiLightColors).forEach((key) => {
        root.style.removeProperty(`--cai-${key}`);
      });
    }
  }, [mode]);

  return null;
}

export default CaiThemeVars;
